import { ApiEnvironments } from '../common/enums';

export const allEnvs: Record<
    ApiEnvironments,
    {
        type: ApiEnvironments;
        wms: string;
        ws: string;
        wsAlt: string | null;
        external: string;
        service: string;
    }
> = {
    [ApiEnvironments.dev]: {
        type: ApiEnvironments.dev,
        wms: 'https://services-dev.flightexplorer.com/WMS',
        ws: 'wss://fes-dev.flightexplorer.com',
        wsAlt: null,
        external: 'https://secure-dev.flightexplorer.com/clientredirect/clientredir2.aspx',
        service: 'https://services-dev.flightexplorer.com'
    } as const,
    [ApiEnvironments.dev2]: {
        type: ApiEnvironments.dev2,
        wms: 'https://services-dev.flightexplorer.com/WMS',
        ws: 'wss://fly-dev.flightexplorer.com',
        wsAlt: null,
        external: 'https://secure-dev.flightexplorer.com/clientredirect/clientredir2.aspx',
        service: 'https://services-dev.flightexplorer.com'
    } as const,
    [ApiEnvironments.cert]: {
        type: ApiEnvironments.cert,
        wms: 'https://services-cert.flightexplorer.com/WMS',
        ws: 'wss://fes-cert.flightexplorer.com',
        wsAlt: null,
        external: 'https://secure-cert.flightexplorer.com/clientredirect/clientredir2.aspx',
        service: 'https://services-cert.flightexplorer.com'
    } as const,
    [ApiEnvironments.prod]: {
        type: ApiEnvironments.prod,
        wms: 'https://services.flightexplorer.com/WMS',
        ws: 'wss://fes1.flightexplorer.com',
        wsAlt: 'wss://fes2.flightexplorer.com',
        external: 'https://secure.flightexplorer.com/clientredirect/clientredir2.aspx',
        service: 'https://services.flightexplorer.com'
    } as const,
    [ApiEnvironments.prodAlt]: {
        type: ApiEnvironments.prodAlt,
        wms: 'https://services2.flightexplorer.com/WMS',
        ws: 'wss://fes2.flightexplorer.com',
        wsAlt: 'wss://fes1.flightexplorer.com',
        external: 'https://secure2.flightexplorer.com/clientredirect/clientredir2.aspx',
        service: 'https://services2.flightexplorer.com'
    } as const,
    [ApiEnvironments.local]: {
        type: ApiEnvironments.local,
        wms: 'https://services-dev.flightexplorer.com/WMS',
        ws: 'wss://fes-dev.flightexplorer.com',
        wsAlt: null,
        external: 'https://secure-dev.flightexplorer.com/clientredirect/clientredir2.aspx',
        service: 'http://localhost:5143'
    } as const
} as const;

export let envConfig = allEnvs[ApiEnvironments.prod];

export function selectEnvironment(env: ApiEnvironments) {
    envConfig = allEnvs[env];
}

export const hostEnvironment = inferEnvironment();
export const loggingEnabled = hostEnvironment === ApiEnvironments.dev;
export const azureAiEnabled = import.meta.env.PROD;
export const canChangeEnvironment = hostEnvironment === ApiEnvironments.dev;

export function getRemoteAuthenticationUrl() {
    return envConfig.service + '/api/v2/auth/community-portal';
}

function inferEnvironment() {
    if (!('location' in globalThis)) {
        return ApiEnvironments.dev;
    }

    switch (location.host) {
        case 'feweb-dev.flightexplorer.com':
            return ApiEnvironments.dev;
        case 'feweb-cert.flightexplorer.com':
            return ApiEnvironments.cert;
        case 'feweb.flightexplorer.com':
            return ApiEnvironments.prod;
        case 'feweb2.flightexplorer.com':
            return ApiEnvironments.prodAlt;
        default:
            return ApiEnvironments.dev;
    }
}

export function isDev(env: ApiEnvironments) {
    return env === ApiEnvironments.dev || env === ApiEnvironments.dev2 || env === ApiEnvironments.local;
}

export function isProd(env: ApiEnvironments) {
    return !isDev(env);
}
